<template>
  <div
    class="toast fade p-0 my-3"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
    ref="toast"
  >
    <div class="toast-header" v-if="toast.title" :class="variantClass">
      <i class="fas fa-bell" />
      <strong class="ms-1 me-auto">{{ toast.title }}</strong>
      <a
        class="btn btn-close mx-2 mb-2 pointer text-white"
        data-bs-dismiss="toast"
        aria-label="Close"
      >
        <i class="fas fa-window-close" />
      </a>
    </div>
    <div class="d-flex">
      <div class="toast-body">
        {{ toast.message }}
      </div>
      <a
        v-if="!toast.title"
        class="me-2 m-auto text-white pointer"
        data-bs-dismiss="toast"
        aria-label="Close"
      >
        <i class="fas fa-window-close fa-2x" />
      </a>
    </div>
  </div>
</template>

<script>
import { bootstrap } from '../plugin';

export default {
  props: ['index', 'toast'],
  data() {
    return {
      obj: null,
    };
  },
  computed: {
    variantClass() {
      let variant = this.toast.variant ?? 'primary';
      let cls = '';
      if (variant) {
        cls = 'bg-' + variant;
      }
      let darkVariants = ['success', 'warning', 'info'];
      if (darkVariants.indexOf(variant) != -1) {
        cls += ' text-dark';
      } else {
        cls += ' text-white';
      }
      return cls;
    },
  },
  mounted() {
    this.autoHideStatus = this.toast.autohide ?? false;
    this.obj = new bootstrap.Toast(this.$refs.toast, {
      autohide: this.autoHideStatus,
    });
    this.obj.show();

    this.$refs.toast.addEventListener('hidden.bs.toast', () => {
      this.obj.hide();
      this.$emit('dismiss', this.index);
    });
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    this.obj.dispose(); // detach bootstrap magic
  },
};
</script>
